<template>
  <b-dropdown
    variant="none"
    toggle-class="city-switcher-toggle text-white d-flex align-items-center border-0 shadow-none"
    menu-class="city-switcher-menu"
    right
    no-caret
  >
    <template #button-content>
      <i :class="isAdminLevel ? 'ri-settings-3-line' : 'ri-map-pin-line'" class="mr-2"></i>
      <span class="city-switcher-label">{{ levelLabel }}</span>
      <i class="ri-arrow-down-s-line ml-1"></i>
    </template>

    <b-dropdown-header>Cambiar de ciudad</b-dropdown-header>

    <b-dropdown-item
      v-for="city in cities"
      :key="city.id"
      :active="currentCity && currentCity.id === city.id"
      @click="goToCity(city)"
    >
      <i class="ri-map-pin-line mr-2"></i>
      {{ city.name }}
      <small class="text-muted d-block ml-4">{{ city.country_name }}</small>
    </b-dropdown-item>

    <b-dropdown-divider></b-dropdown-divider>

    <b-dropdown-item :active="isAdminLevel" @click="goToAdmin()">
      <i class="ri-settings-3-line mr-2"></i>
      Administración
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { ADMIN_HOME_ROUTE, CITY_HOME_ROUTE } from "@/core/utils/menus";

export default {
  name: "CitySwitcher",
  computed: {
    ...mapGetters({
      cities: "city/getCities",
      currentCity: "city/getCurrentCity",
      isAdminLevel: "city/isAdminLevel",
      levelLabel: "city/getLevelLabel",
    }),
  },
  methods: {
    // Al cambiar el nivel, PageBase remonta la página (key por ciudad) y esta
    // vuelve a pedir sus datos con el nuevo X-City-Id. Lo que importa es el
    // orden entre navegar y cambiar de ciudad: la página que se remonta tiene
    // que tener sentido en la ciudad nueva.
    async goToCity(city) {
      if (this.currentCity && this.currentCity.id === city.id) return;
      const route = this.$route;
      const hasParams = Object.keys(route.params || {}).length > 0;

      if (!this.currentCity) {
        // Desde Administración se entra a la ciudad por Viajes. Primero la
        // ciudad: Viajes necesita X-City-Id desde que monta.
        await this.$store.dispatch("city/selectCity", city);
        await this.$router.push({ name: CITY_HOME_ROUTE });
      } else if (hasParams) {
        // Pantalla de detalle o edición (/proveedores/12): esa entidad es de la
        // ciudad anterior. Se sale a Viajes antes de cambiar, para que el
        // detalle no intente recargarse en la ciudad nueva.
        await this.$router.push({ name: CITY_HOME_ROUTE });
        await this.$store.dispatch("city/selectCity", city);
      } else {
        // Listados y formularios nuevos: se queda en la misma pantalla y se
        // recarga. La página y los filtros del query son de la ciudad anterior,
        // así que se limpian primero.
        if (Object.keys(route.query || {}).length) {
          await this.$router.replace({ name: route.name });
        }
        await this.$store.dispatch("city/selectCity", city);
      }
    },
    async goToAdmin() {
      if (this.isAdminLevel) return;
      // Primero se sale de la pantalla de ciudad: si se cambiara el nivel antes,
      // la página se remontaría sin X-City-Id y sus pedidos fallarían.
      await this.$router.push({ name: ADMIN_HOME_ROUTE });
      await this.$store.dispatch("city/selectAdminLevel");
    },
  },
  async mounted() {
    if (!this.$store.getters["city/areCitiesLoaded"]) {
      try {
        await this.$store.dispatch("city/loadCities");
      } catch (e) {
        console.error(e);
      }
    }
  },
};
</script>

<style lang="stylus">
.city-switcher-toggle
  background: transparent
  font-size: 14px
  &:hover, &:focus
    background: rgba(255, 255, 255, 0.1)

.city-switcher-label
  font-weight: 600

.city-switcher-menu
  min-width: 220px
</style>
